/* eslint no-param-reassign: "off" */

import initWrapper from './lib/init';

const Topics = module.parent.require('./topics');
const settings = module.parent.require('./meta');

export const init = initWrapper(Topics, settings);

export const defineWidgets = function defineWidgets(widgets, callback) {
  widgets.push({
    widget: 'leech-button',
    name: 'Leech Button',
    description: 'leech content from many sources and convert to NodeBB posts',
    content: '',
  });
  callback(null, widgets);
};

export const renderLeechButton = function renderLeechButton(widget, callback) {
  // console.log(widget.area.template);
  if (['category.tpl', 'topic.tpl'].includes(widget.area.template)) {
    widget.req.app.render('widgets/leech-button', (err, html) => {
      widget.html = html;
      callback(err, widget);
    });
  } else {
    widget.html = '';
    callback(null, widget);
  }
};

export const addAdminNavigation = function addAdminNavigation(header, callback) {
  header.plugins.push({
    route: '/plugins/leech-tool',
    icon: 'fa-download',
    name: 'Leech Tool',
  });

  callback(null, header);
};

// export const appendConfig = (config, callback) => {
//   meta.settings.get('leech-tool', (err, settings) => {
//     if (err) {
//       callback(null, config);
//     }
//
//     config['leech-tool'] = settings;
//     callback(null, config);
//   });
// };
